// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth"
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore"
import { getAnalytics, logEvent as firebaseLogEvent } from "firebase/analytics";
import { getStorage, connectStorageEmulator } from "firebase/storage";
const { initializeAppCheck, ReCaptchaV3Provider } = require("firebase/app-check");

const useEmulators = process.env.REACT_APP_USE_EMULATORS === "true";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD2ryWLsbPorJPx0G3eoviq6EdIV_R18hc",
  authDomain: "stairbuilder-app.firebaseapp.com",
  projectId: "stairbuilder-app",
  storageBucket: "stairbuilder-app.firebasestorage.app",
  messagingSenderId: "901136126971",
  appId: "1:901136126971:web:e5fea9a6b5edff79a4315e"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

if (!useEmulators) {
  // self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;  // Use this when you need to get a local debug token to add to app check
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider('6LdU3owtAAAAADWJQsxRStIXiGlT06co7Tq2tNuJ'),
    isTokenAutoRefreshEnabled: true
  });
}

export const auth = getAuth(app)
export const db = getFirestore(app)
export const analytics = useEmulators ? null : getAnalytics(app);

// Safe wrapper: no-op when analytics is null (emulator mode)
export const safeLogEvent = (...args) => {
  if (analytics) firebaseLogEvent(analytics, ...args);
};

if (useEmulators) {
  connectAuthEmulator(auth, "http://localhost:9099");
  connectFirestoreEmulator(db, "localhost", 8080);
  const storage = getStorage(app);
  connectStorageEmulator(storage, "localhost", 9199);
}